import React, { useEffect, useState, useRef } from "react";
import Axios from "axios";
import { GetCandidateEvaluations } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import nodataimg from "../assets/images/Nodata.jpg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const safeParse = (jsonStr) => {
  try {
    if (!jsonStr || jsonStr === "undefined" || jsonStr === "null") return {};
    return JSON.parse(jsonStr);
  } catch (e) {
    console.error("Error parsing JSON:", jsonStr, e);
    return {};
  }
};

const ViewEvaluationPersonDetails = () => {
  const query = useQuery();
  const jobPost = query.get("jobPost");
const candidatesID = query.get("candidatesID");
  const [evaluation, setEvaluation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const printRef = useRef(null);
const token = localStorage.getItem("jwtToken");
  const GetCandidateDetails = async () => {
    setIsLoading(true);
    try {
      const res = await Axios.get(`${GetCandidateEvaluations.APIURL}?jobPostId=${jobPost}&CandidatesID=${candidatesID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = res.data || [];
      if (data.length > 0) {
        const latest = data
          .map(item => ({ ...item, evaluationJson: safeParse(item.evaluationJson) }))
          .sort((a, b) => new Date(b.evaluationDate) - new Date(a.evaluationDate))[0];
        setEvaluation(latest);
      } else {
        setEvaluation(null);
      }
    } catch (err) {
      console.error("Error fetching candidate details:", err);
      setEvaluation(null);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    GetCandidateDetails();
  }, []);

  if (isLoading)
    return (
      <ConsultantLayout>
        <center><LoadingSpinner /></center>
      </ConsultantLayout>
    );

  if (!evaluation)
    return (
      <ConsultantLayout>
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <img src={nodataimg} alt="No Data" style={{ width: "100%", maxWidth: 500 }} />
        </div>
      </ConsultantLayout>
    );

  const evalData = evaluation.evaluationJson || {};
  const certifications = evaluation.certifications ? evaluation.certifications.split(",").map(c => c.trim()) : [];

  return (
    <ConsultantLayout>
      <div className="container-fluid mt-3">
        <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
          <Link to="/Employer/ListOfJobPosts">
            <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: 10 }} aria-hidden="true"></i>
          </Link>
          <h2 style={{ color: "#00a7ac", margin: 0 }}>Evaluation Result</h2>
        </div>
        <hr/>
        <div ref={printRef} style={{ padding: "20px", backgroundColor: "#fff" }}>
          <div style={{
            marginTop: "20px",
            width: "100%",
            padding: "20px",
            borderRadius: "10px",
            display: "flex",
            flexWrap: "wrap",
          }}>
            {/* Left Column */}
            <div style={{ width: "30%", paddingRight: "20px", borderRight: "1px solid #ddd" }}>
              <p style={{ fontSize: "18px" }}><strong>Name:</strong> {evaluation.fullName || "N/A"}</p>
              <p style={{ fontSize: "18px" }}><strong>Email:</strong> {evaluation.email || "N/A"}</p>
              <p style={{ fontSize: 18, display: 'flex', alignItems: 'center' }}>
                <strong>Phone Number:</strong> {evaluation.mobileNumber || "N/A"}
                {evaluation.mobileNumber && (
                  <a href={`tel:${evaluation.mobileNumber}`} title="Click to Call" style={{ marginLeft: 10, color: "#00a7ac" }}>
                    <i className="fas fa-phone"></i>
                  </a>
                )}
              </p>
              {/* <p style={{ fontSize: "18px" }}><strong>Evaluated By:</strong> {evaluation.evaluatedBy || "N/A"}</p>
              <p style={{ fontSize: "18px" }}><strong>Evaluation Date:</strong> {evaluation.evaluationDate || "N/A"}</p>
              <p style={{ fontSize: "18px" }}><strong>Job Post ID:</strong> {evaluation.jobPostID || "N/A"}</p>
              <p style={{ fontSize: "18px" }}><strong>Outreach ID:</strong> {evaluation.outreachID || "N/A"}</p> */}

              {certifications.length > 0 ? (
                <>
                  <hr />
                  <p style={{ fontSize: "18px" }}>
                    <strong>🎓 Candidates Certifications:</strong>
                    <ul>{certifications.map((cert, idx) => <li key={idx}>{cert}</li>)}</ul>
                  </p>
                </>
              ) : (
                <p style={{ fontSize: "18px" }}><strong>🎓 Candidates Certifications:</strong> N/A</p>
              )}
              <hr/>
              {/* ❌ Skill Gaps */}
{evalData?.skillGaps?.length ? (
  <>
    <p style={{ fontSize: 16, marginBottom: 6 }}>
      <strong style={{ color: "#00a7ac" }}>❌ Skill Gaps:</strong>
    </p>

    <div style={{ fontSize: 14, marginBottom: 6 }}>
      {evalData.skillGaps.map((gap, idx) => (
        <div key={idx}>
          {gap["JD Skill"] || "N/A"} — Found: {gap["Found in Resume"] || "N/A"}, Match:{" "}
          {gap.Match || "N/A"}
        </div>
      ))}
    </div>

    <hr />

    <div style={{ fontSize: 12, marginBottom: 6 }}>
      <span style={{ marginRight: 15 }}>✅ Full Match</span>
      <span style={{ marginRight: 15 }}>🔶 Partial Match</span>
      <br />
      <span>❌ Skills Missing</span>
    </div>

    <hr />
  </>
) : (
  <>
    <p style={{ fontSize: 16 }}>
      <strong style={{ color: "#00a7ac" }}>❌ Skill Gaps:</strong> N/A
    </p>
    <hr />
  </>
)}
            </div>

            {/* Right Column */}
            <div style={{ width: "70%", paddingLeft: "20px" }}>
             <p style={{ fontSize: "18px", color: "#00a7ac" }}>
                <strong>📈 Fit Score:</strong>
                <span style={{ fontSize: 30, color: '#000' }}> {evalData.fitMatchScore !== undefined ? evalData.fitMatchScore : "N/A"}%</span>
              </p>
              <hr />

              <p style={{ fontSize: 16 }}>
                <strong style={{ color: "#00a7ac" }}>High-Level Fit Summary:</strong>
                <p style={{ fontSize: 18,}}>
                  {evalData.overallSummary || "N/A"}
                </p>
              </p>

              <hr />
              <p style={{ fontSize: 16 }}>
                <strong style={{ color: "#00a7ac" }}>📌 JD Skills Matched in Recent Projects:</strong>
                {evalData.matchedSkillsInRecentProjects && evalData.matchedSkillsInRecentProjects.length > 0 ? (
                  <ul>
                    {evalData.matchedSkillsInRecentProjects.map((item, idx) => (
                      <li key={idx}>{item["JD Skill"] || "N/A"} — {item["Found in Project"] || "N/A"}</li>
                    ))}
                  </ul>
                ) : (
                  <span> N/A</span>
                )}
              </p>

              <hr />

              <p style={{ fontSize: 16 }}>
                <strong style={{ color: "#00a7ac" }}>💡 Improvement Insights:</strong>
                {evalData.improvementInsights && evalData.improvementInsights.length > 0 ? (
                  <ul>{evalData.improvementInsights.map((insight, idx) => <li key={idx}>{insight}</li>)}</ul>
                ) : (
                  <span> N/A</span>
                )}
              </p>

              <hr />

              <p style={{ fontSize: 16 }}>
                <strong style={{ color: "#00a7ac" }}>Inconsistency Check:</strong> {evalData.inconsistencyCheck || "N/A"}
              </p>

            </div>
          </div>
        </div>
      </div>
    </ConsultantLayout>
  );
};

export default ViewEvaluationPersonDetails;
